import { AppMenu, AppUserMenu } from '@/api/models';

export interface IModuleSettings {
  tourBag: boolean;
}

const mouduleMap = {
  TourBag: {
    name: 'Tour Bag',
  },
  // Add more modules as the migration continues (i.e.: 'Order', 'Admin', etc.)
};

interface IGetModuleSettingsProps {
  appMenus: AppMenu[];
  userMenus: AppUserMenu[];
}

export const getModuleSettings = ({ appMenus, userMenus }: IGetModuleSettingsProps) => {
  const tourBagAppMenu = appMenus.find((appMenu) => appMenu.name === mouduleMap.TourBag.name);

  if (!tourBagAppMenu) return { tourBag: false };

  // Get all child app menus of Tour Bag
  const tourBagChildrenIds = appMenus.filter((appMenu) => appMenu.parentAppMenuId === tourBagAppMenu.appMenuId).map((child) => child.appMenuId);

  // Check if user has parent OR any child
  const hasTourBagAccess = userMenus.some((userMenu) => userMenu.appMenuId === tourBagAppMenu.appMenuId || tourBagChildrenIds.includes(userMenu.appMenuId));

  // TODO: Refactor when adding more modules is required
  const moduleSettings = {
    tourBag: hasTourBagAccess,
  };
  return moduleSettings;
};
